import React from "react";
import { BsShieldCheck } from "react-icons/bs";
import { FaMotorcycle } from "react-icons/fa";
import { MdGpsFixed, MdOutlinePriceCheck } from "react-icons/md";

import classes from "./Styles/Dispatch.module.css";
import { getDownloadLink } from "../../utils/appLinks";

function Dispatch() {
  return (
    <div className={`${classes.main} ${classes.about_main}`}>
      <div className={`${classes.data} ${classes.about_data}`}>
        <span className={classes.eyebrow}>Dispatch delivery</span>

        <h1>
          Send it now with a{" "}
          <span className={classes.highlight}>dispatch rider</span> near you
        </h1>

        <p>
          From documents to packages, get a verified rider to pick up and
          drop off anywhere in the city. Real-time tracking from pickup to
          doorstep, every single time.
        </p>

        <div className={`${classes.flex_btm_box} ${classes.col_formart}`}>
          <div className={classes.row_format}>
            <i className={classes.iconChip} data-tone="blue">
              <FaMotorcycle size={20} />
            </i>
            <div>
              <h3>Instant Pickup</h3>
              <p>
                Request a rider and get picked up in minutes, not hours.
                Available across the city, all day.
              </p>
            </div>
          </div>

          <div className={classes.row_format}>
            <i className={classes.iconChip} data-tone="amber">
              <MdGpsFixed size={20} />
            </i>
            <div>
              <h3>Live GPS Tracking</h3>
              <p>
                Watch your delivery move in real time, from your rider's
                location to your drop-off address.
              </p>
            </div>
          </div>

          <div className={classes.row_format}>
            <i className={classes.iconChip} data-tone="green">
              <BsShieldCheck size={20} />
            </i>
            <div>
              <h3>Verified Riders</h3>
              <p>
                Every rider is background-checked and rated, so your package
                is always in safe hands.
              </p>
            </div>
          </div>

          <div className={classes.row_format}>
            <i className={classes.iconChip} data-tone="purple">
              <MdOutlinePriceCheck size={20} />
            </i>
            <div>
              <h3>Fair, Upfront Pricing</h3>
              <p>
                See your delivery cost before you book. No surge surprises,
                no hidden fees.
              </p>
            </div>
          </div>
        </div>

        <div className={classes.ctaRow}>
            <a href={getDownloadLink()} target="_blank" rel="noopener noreferrer">
          <button className={classes.ctaButton}>
              Book a rider →
          </button>
            </a>
          <span className={classes.ctaNote}>Average pickup time: 8 mins</span>
        </div>
      </div>

      <div className={`${classes.image_wrapper} ${classes.image_wrapper2}`}>
        <div className={classes.floatingBadge}>
          <span className={classes.dot} />
          Rider en route
        </div>

        <img
          className={classes.logo_large}
          src="/images/ride/pick.png"
          alt="Sprinterwave dispatch rider making a delivery"
        />
      </div>
    </div>
  );
}

export default Dispatch;